import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { useUserClient } from '@juvare/platform-sdk-react/ui/hooks';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CachedIcon from '@mui/icons-material/Cached';
import { Box, Button } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';
export const AccountProfileHeaderActions = ({ showBack, showSwitchToUser, accountEmail, }) => {
    const { t } = useContactManagementTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const navigationContext = React.useContext(NavigationContext);
    const userClient = useUserClient();
    const handleSwitchToUser = () => {
        userClient
            .switchUser({
            provider: 'switch',
            user: accountEmail,
        })
            .then((response) => {
            window.location.assign(response.loginSuccessUrl);
        })
            .catch(handleErrorDialog);
    };
    return (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between' }, "data-test": 'actions' },
        showBack ? (React.createElement(Button, { variant: 'text', color: 'inherit', startIcon: React.createElement(ArrowBackIcon, null), onClick: () => navigationContext.navigate(() => { var _a; return (((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) ? navigate(-1) : navigate('..')); }), "data-test": 'back-button' }, t('common.back'))) : (React.createElement(Box, null)),
        showSwitchToUser && (React.createElement(Button, { sx: { color: themeColors.decorative.white }, startIcon: React.createElement(CachedIcon, null), onClick: () => handleSwitchToUser(), "data-test": 'switch-to-user-button' }, t('panels.accounts.switchToThisUser')))));
};
